import React, { useEffect, useState } from "react";
import { Box, Container, Stack, useMediaQuery } from "@mui/material";
import { Header, Footer, Hero, Tips, BusinessLeadersTips, AdditionalInformation, LearnMore } from "layout";
import { BackToTop } from "components";
import { desktop } from "utils";
import wave2 from "assets/images/wave2.png";
import wave3 from "assets/images/wave3.png";
import ReCAPTCHA from "react-google-recaptcha";

export const Layout = () => {
  const matchesDesktop = useMediaQuery(desktop);

  const recaptchaRef = React.createRef();

  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <>
      {loaded && (
        <ReCAPTCHA sitekey="6LfmMaYlAAAAAFP-iHLxRFtpz3y79Zw6fTmvaLos" ref={recaptchaRef} size="invisible" hl="lt" />
      )}

      <Stack height="100vh">
        <Header />

        <Hero recaptchaRef={recaptchaRef} />

        <Box pt={matchesDesktop ? "4rem" : "1rem"} pb="4rem" id="SužinokDaugiau">
          <Container maxWidth="lg">
            <LearnMore />
          </Container>
        </Box>

        <Box
          sx={{
            backgroundImage: `url(${wave2})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "bottom",
            backgroundSize: "100%",
            padding: "1%",
          }}
        />

        <Box pb="4rem" backgroundColor="background2.main">
          <Container maxWidth="xl">
            {/* <Box py="2rem" id="Konsultacija">
              <FinancialConsultation />
            </Box> */}
            <Box pt="4rem" pb="9rem" id="Patarimai">
              <Tips />
            </Box>
            <BusinessLeadersTips />
          </Container>
        </Box>

        <Box
          sx={{
            backgroundImage: `url(${wave3})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "bottom",
            backgroundSize: "100%",
            padding: "1%",
          }}
        />

        <Container
          maxWidth="xl"
          sx={{
            py: "3rem",
          }}
        >
          <AdditionalInformation />
        </Container>

        <Footer />

        <BackToTop />
      </Stack>
    </>
  );
};
